import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=0207e54e&"
import script from "./Logs.vue?vue&type=script&lang=js&"
export * from "./Logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0207e54e')) {
      api.createRecord('0207e54e', component.options)
    } else {
      api.reload('0207e54e', component.options)
    }
    module.hot.accept("./Logs.vue?vue&type=template&id=0207e54e&", function () {
      api.rerender('0207e54e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Leads/Tabs/Logs.vue"
export default component.exports